// extracted by mini-css-extract-plugin
export default {"subtitle":"iJ9c7S"};